import {ThemeProvider as MUIThemeProvider} from '@mui/material';
import {theme} from './index.js';

const ThemeProvider = props => (
  <MUIThemeProvider theme={theme} modeStorageKey="pl-mode" {...props} />
);

export default ThemeProvider;
